import type { OrgUnitRow } from "@/api/management";
import type { RunForestNode } from "@/api/config-migration";
import {
  buildOrgStructureForest,
  type OrgTreeNode,
  type MigrationStatus,
} from "@/lib/org-structure-tree";
/** Adaptador de uma linha paginada; detalhes e ancestrais são lidos somente ao abrir a unidade. */
export function orgNodeFromRow(
  row: OrgUnitRow,
  wire?: RunForestNode,
): OrgTreeNode {
  return {
    key: row.key,
    levelCode: row.level_code,
    levelName: row.level_name,
    unitTypeKey: row.level_code,
    unitTypeLabel: row.level_name,
    id: row.id,
    name: row.name ?? null,
    status: "data",
    country: row.country ?? null,
    city: wire?.unit.city ?? null,
    localCurrency: wire?.unit.local_currency ?? null,
    subtype: row.subtype ?? null,
    migrationStatus: (row.migration_status ?? "pending") as MigrationStatus,
    nameStatus: row.name_status === "extracted" ? "extracted" : "not_extracted",
    relationStatus: row.parent_key ? "assigned" : "not_applicable",
    nameSource: "not_available",
    conformity: { status: "not_evaluable", rule: "", reason: "" },
    orphanReason: null,
    parent: null,
    parentId: row.parent_id ?? null,
    lastRunId: row.last_run_id ?? null,
    pendingDecision: null,
    migrationItemId: null,
    itemKey: row.item_key,
    origin: row.origin === "manual" ? "manual" : "sap",
    scopeVerdict: row.scope_verdict,
    overriddenFields: row.overridden_fields,
    originalValues: row.original_values,
    targetId: row.target_id ?? null,
    children: [],
  };
}

export function orgNodeFromContext(
  context: import("@/api/org-execution").OrgUnitContext,
): OrgTreeNode {
  if (context.snapshot) {
    const row = context.row;
    const status = (row.migration_status ?? "pending") as MigrationStatus;
    const roots = buildOrgStructureForest(context.snapshot.levels, [
      {
        item_type: row.level_code,
        item_key: row.item_key,
        status,
        outcome: null,
        external_id: null,
        attempts: 0,
        last_run_id: row.last_run_id ?? null,
      },
    ]).roots;
    const find = (nodes: OrgTreeNode[]): OrgTreeNode | undefined => {
      for (const node of nodes) {
        if (`${node.levelCode}|${node.itemKey}` === row.key) return node;
        const child = find(node.children);
        if (child) return child;
      }
    };
    const node = find(roots);
    if (node) return { ...node, key: row.key };
  }
  return orgNodeFromRow(context.row, context.unit);
}
